import { Routes, Route } from "react-router-dom";

import HomePage from "../pages/Home";
import UserPage from "../pages/UserPage";
import ConsultasPage from "../pages/ConsultasPage";
import ExamesPage from "../pages/ExamesPage";
import AtendimentoDetalhesPage from "../pages/AtendimentoDetalhesPage";
import ProfissionalPage from "../pages/ProfissionalPage";
import PagamentoPage from "../pages/PagamentoPage";
import InfoPage from "../pages/InfoPage";
import AtendimentoPage from "../pages/AtendimentoPage";

import PartnerRoute from "./routePartner";
import PublicRoute from "./routePublic";
import PrivateRoute from "./routePrivate";
import LoginPage from "../pages/LoginPage";
import WaitRoomPage from "../pages/WaitRoomPage";
import NotFoundPage from "../pages/NotFoundPage";

const Router = () => {
  return (
    <Routes>
      <Route path="/:partnerUrl" element={<PartnerRoute />}>
        <Route element={<PublicRoute />}>
          <Route path="" element={<HomePage />} />
          <Route path="user" element={<UserPage />} />
          <Route path="profissional" element={<ProfissionalPage />} />
          <Route path="login" element={<LoginPage />} />
        </Route>

        <Route element={<PrivateRoute />}>
          <Route path="consultas" element={<ConsultasPage />} />
          <Route path="exames" element={<ExamesPage />} />
          <Route path="atendimento-detalhes" element={<AtendimentoDetalhesPage />} />
          <Route path="pagamento" element={<PagamentoPage />} />
          <Route path="info" element={<InfoPage />} />
          <Route path="waitRoom" element={<WaitRoomPage />} />
          <Route path="atendimento" element={<AtendimentoPage />} />
        </Route>
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default Router;
